import React from 'react';

// constants
import { ADD_BONUS, BACK, EDIT_BONUS, ENABLE_BONUS } from './constants';

import TopToolbar from '../../global/subcomponents/topToolbar/TopToolbar';

import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import SaveIcon from '@material-ui/icons/Save';
import { Divider, TextField } from '@material-ui/core';
import {
  KeyboardTimePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { IconButton } from '@mui/material';
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import InputAdornment from '@material-ui/core/InputAdornment';
import { format,utcToZonedTime, zonedTimeToUtc } from 'date-fns-tz';

class BonusAddForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: this.getValue('name'),
      enabled: this.getValue('enabled'),
      manageBonusId: this.getValue('manageBonusId'),
      specifications: this.getValue('specifications') || [
        { description: '', amount: '' },
      ],
      requiredList: ['name'],
      editBonus: this.props.editBonus,
      weekdays: this.convertWeekdaysData(this.getValue('weekdays') || []),
    };
  }

  formatTimeInChicago = (date) => {
    if (!date) return null;

    return format(date, 'HH:mm', { timeZone: 'America/Chicago' }) + ':00';
  };

  parseTimeStringToDateInChicago = (timeStr) => {
    if (!timeStr) return null;
    const now = new Date();
    const chicagoDateString = `${now.getFullYear()}-${String(
      now.getMonth() + 1
    ).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}T${timeStr}`;

    return zonedTimeToUtc(chicagoDateString, 'America/Chicago');
  };

  convertWeekdaysData = (weekdaysArray) => {
    const weekdays = {
      Monday: { checked: false, times: [] },
      Tuesday: { checked: false, times: [] },
      Wednesday: { checked: false, times: [] },
      Thursday: { checked: false, times: [] },
      Friday: { checked: false, times: [] },
      Saturday: { checked: false, times: [] },
      Sunday: { checked: false, times: [] },
    };

    weekdaysArray.forEach((dayData) => {
      const day = dayData.day;
      if (dayData.checked && weekdays[day]) {
        weekdays[day] = {
          checked: true,
          times: dayData.times.map((slot) => ({
            startTime: this.parseTimeStringToDateInChicago(slot.startTime),
            endTime: this.parseTimeStringToDateInChicago(slot.endTime),
          })),
        };
      }
    });

    return weekdays;
  };

  handleCheckboxChange = (day) => {
    this.setState((prevState) => ({
      weekdays: {
        ...prevState.weekdays,
        [day]: prevState.weekdays[day]?.checked
          ? { checked: false, times: [] } // Unchecking resets times
          : { checked: true, times: [] }, // Just check, no time slots yet
      },
    }));
  };

  handleTimeChange = (day, index, field, time) => {
    const updatedTimes = [...this.state.weekdays[day].times];
    updatedTimes[index][field] = time;
    this.setState((prevState) => ({
      weekdays: {
        ...prevState.weekdays,
        [day]: { ...prevState.weekdays[day], times: updatedTimes },
      },
    }));
  };

  addTimeSlot = (day) => {
    this.setState((prevState) => ({
      weekdays: {
        ...prevState.weekdays,
        [day]: {
          ...prevState.weekdays[day],
          times: [
            ...prevState.weekdays[day].times,
            { startTime: null, endTime: null },
          ],
        },
      },
    }));
  };

  removeTimeSlot = (day, index) => {
    const updatedTimes = [...this.state.weekdays[day].times];
    updatedTimes.splice(index, 1);
    this.setState((prevState) => ({
      weekdays: {
        ...prevState.weekdays,
        [day]: { ...prevState.weekdays[day], times: updatedTimes },
      },
    }));
  };

  addSpecification = () => {
    this.setState((prevState) => ({
      specifications: [
        ...prevState.specifications,
        { description: '', amount: '' },
      ],
    }));
  };

  removeSpecification = (index) => {
    const updatedSpecs = [...this.state.specifications];
    updatedSpecs.splice(index, 1);
    this.setState({ specifications: updatedSpecs });
  };

  handleSpecChange = (index, field, value) => {
    const updatedSpecs = [...this.state.specifications];
    updatedSpecs[index][field] = value;
    this.setState({ specifications: updatedSpecs });
  };

  handleChange = (e) => {
    const { name, value } = e.target;

    this.setState({
      [name]: value,
    });
  };

  isHandleSave = () => {
    const { weekdays, specifications, requiredList } = this.state;

    // Check if any checked weekday is missing startTime or endTime
    const invalidWeekday = Object.values(weekdays).some(
      (day) =>
        day.checked &&
        day.times.some((time) => !time.startTime || !time.endTime)
    );

    // Check if any specification has an empty description or amount
    const invalidSpecification = specifications.some(
      (spec) => !spec.description.trim() || !spec.amount.trim()
    );

    // Check required fields
    const missingRequiredFields = requiredList.some(
      (field) => !this.state[field]
    );

    return invalidWeekday || invalidSpecification || missingRequiredFields;
  };

  getValue = (key) => {
    if (!this.props.editBonus) {
      return key === 'enabled' ? false : '';
    }

    const value = this.props.editBonus[key];

    if (value === undefined || value === null || value === '') {
      return key === 'enabled' ? false : '';
    }

    return value;
  };

  handleSave = () => {
    const { manageBonusId, name, enabled, specifications, weekdays } =
      this.state;

    const formattedWeekdays = Object.entries(weekdays)
      .map(([day, data]) => {
        if (!data.checked) return null;

        return {
          day,
          checked: true,
          times: data.times.map((slot) => ({
            startTime: this.formatTimeInChicago(slot.startTime),
            endTime: this.formatTimeInChicago(slot.endTime),
          })),
        };
      })
      .filter(Boolean);

    const data = {
      manageBonusId,
      specifications,
      locationId: this.props.user.selectedLocationId,
      name,
      enabled,
      weekdays: formattedWeekdays,
    };

    this.props.saveBonus(
      data,
      (data) => {
        this.props.handleEditingClear();
        this.props.openFeedbackBar('success', 'Saved');
      },
      (message) => {
        this.props.openFeedbackBar('error', message);
      }
    );
  };

  render() {
    return (
      <React.Fragment>
        <TopToolbar
          pageName={this.props.editBonus ? EDIT_BONUS : ADD_BONUS}
          menuItems={[
            {
              title: BACK,
              icon: <KeyboardBackspaceIcon />,
              onClick: () => {
                this.props.handleEditingClear();
              },
            },
            {
              title: 'Save',
              icon: <SaveIcon />,
              disabled: this.isHandleSave(),
              onClick: () => this.handleSave(),
            },
          ]}
        />

        <div style={{ marginBottom: '24px' }}>
          <div style={{ marginTop: '24px' }}>
            <div>
              <div className="rowSpecBonus">
                <TextField
                  style={{ marginLeft: '16px', marginRight: '16px' }}
                  className="input-text-field"
                  variant="outlined"
                  label="Name"
                  InputLabelProps={{ shrink: true }}
                  name="name"
                  value={this.state.name}
                  required={this.state.requiredList.includes('name')}
                  onChange={this.handleChange}
                />
              </div>

              <FormControlLabel
                style={{ marginLeft: '8px', width: 225, whiteSpace: 'nowrap' }}
                control={
                  <Checkbox
                    checked={this.state.enabled}
                    onChange={(e) =>
                      this.setState({ enabled: e.target.checked })
                    }
                  />
                }
                label={ENABLE_BONUS}
              />

              <div style={{ marginLeft: '16px', marginTop: '16px' }}>
                <h4>Specify</h4>
                <Divider style={{ marginBottom: '16px', marginTop: '16px' }} />
              </div>

              <div className="" style={{ marginTop: '16px' }}>
                {this.state.specifications.map((spec, index) => (
                  <div
                    key={index}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      marginLeft: '8px',
                      marginRight: '8px',
                    }}
                  >
                    <TextField
                      className="input-text-field"
                      label="Description"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={spec.description}
                      onChange={(e) =>
                        this.handleSpecChange(
                          index,
                          'description',
                          e.target.value
                        )
                      }
                      variant="outlined"
                    />
                    <TextField
                      className="input-text-field"
                      label="Amount"
                      value={spec.amount}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">$</InputAdornment>
                        ),
                      }}
                      onChange={(e) =>
                        this.handleSpecChange(index, 'amount', e.target.value)
                      }
                      variant="outlined"
                      type="number"
                    />
                    <IconButton onClick={() => this.removeSpecification(index)}>
                      <RemoveCircleIcon fontSize="medium" color="error" />
                    </IconButton>
                  </div>
                ))}
              </div>

              <IconButton
                onClick={this.addSpecification}
                style={{ marginLeft: '8px', marginRight: '8px' }}
              >
                <AddCircleIcon fontSize="medium" color="secondary" />
              </IconButton>
            </div>
          </div>

          <div style={{ marginLeft: '16px', marginTop: '16px' }}>
            <h4>Select Weekdays & Time</h4>
            <Divider style={{ marginBottom: '16px', marginTop: '16px' }} />
          </div>

          <div style={{ marginLeft: '16px' }}>
            {[
              'Monday',
              'Tuesday',
              'Wednesday',
              'Thursday',
              'Friday',
              'Saturday',
              'Sunday',
            ].map((day) => (
              <div key={day}>
                <FormControlLabel
                  control={
                    <Checkbox
                      color="primary"
                      checked={!!this.state.weekdays[day]?.checked}
                      onChange={() => this.handleCheckboxChange(day)}
                    />
                  }
                  label={day}
                />

                {this.state.weekdays[day]?.checked && (
                  <div>
                    {this.state.weekdays[day].times.length === 0 ? (
                      <IconButton onClick={() => this.addTimeSlot(day)}>
                        <AddCircleIcon fontSize="medium" color="secondary" />
                      </IconButton>
                    ) : (
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        {this.state.weekdays[day].times.map(
                          (timeSlot, index) => (
                            <div
                              key={index}
                              style={{ display: 'flex', alignItems: 'center' }}
                            >
                              <KeyboardTimePicker
                                className="input-text-field"
                                label="Start Time"
                                InputLabelProps={{ shrink: true }}
                                value={utcToZonedTime(timeSlot.startTime, 'America/Chicago')}
                                onChange={(time) =>
                                  this.handleTimeChange(
                                    day,
                                    index,
                                    'startTime',
                                    time
                                  )
                                }
                                inputVariant="outlined"
                              />
                              <KeyboardTimePicker
                                className="input-text-field"
                                label="End Time"
                                InputLabelProps={{ shrink: true }}
                                value={utcToZonedTime(timeSlot.endTime, 'America/Chicago')}
                                onChange={(time) =>
                                  this.handleTimeChange(
                                    day,
                                    index,
                                    'endTime',
                                    time
                                  )
                                }
                                inputVariant="outlined"
                              />
                              <IconButton
                                onClick={() => this.removeTimeSlot(day, index)}
                              >
                                <RemoveCircleIcon
                                  fontSize="medium"
                                  color="error"
                                />
                              </IconButton>
                            </div>
                          )
                        )}
                        <IconButton onClick={() => this.addTimeSlot(day)}>
                          <AddCircleIcon fontSize="medium" color="secondary" />
                        </IconButton>
                      </MuiPickersUtilsProvider>
                    )}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </React.Fragment>
    );
  }
}


export default BonusAddForm;